import type React from "react";
import { Navigate, useLocation } from "react-router";

import { type AuthContextInterface, useAuth } from "~/features/authn/context";
import { createAuthReturnIntent } from "~/features/authn/navigationIntent";
import { rootRoute as R } from "~/routes";

type RequireAuthProps = {
  children: React.ReactNode;
};
export const RequireAuth: React.FC<RequireAuthProps> = ({ children }) => {
  const { user } = useAuth() as AuthContextInterface;
  const location = useLocation();

  if (!user) {
    const returnIntent = createAuthReturnIntent({ location });
    return <Navigate to={R.signIn.$buildPath({ searchParams: returnIntent })} replace />;
  }

  return <>{children}</>;
};
